import {
    DigestFilter,
    DigestFilterColumn,
    DigestFilterOperator,
    DigestLogicalOperator,
} from "../../../../../../Common/CandyApiClient/DigestApiClient/Types/DigestQueryFilter";

export const buildSearchFilter = (value: string, fields: string[]): DigestFilter => ({
    operator: DigestLogicalOperator.Or,
    operands: fields.map(
        (fieldName): DigestFilterColumn => ({
            operator: DigestFilterOperator.Substring,
            column: fieldName,
            value: value,
        })
    ),
});

export const buildEqualValueFilter = (value: string, searchByField: string): DigestFilter => {
    const multipleValues = splitValues(value);

    return {
        operator: DigestLogicalOperator.Or,
        operands: multipleValues.map(
            (val): DigestFilterColumn => ({
                operator: DigestFilterOperator.Equal,
                column: searchByField,
                value: val,
            })
        ),
    };
};

export const splitValues = (value: string): string[] =>
    value
        .split(",")
        .map(v => v.trim())
        .filter(x => x !== "");
